const themeFonts = {
    // Headings follow the netsnek docs: the plain sans stack. Playfair, the
    // serif the site used here before, was hard to read at article-heading
    // sizes; it survives as `display` for the one place that wants it, the
    // hero name.
    heading: `Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
    display: `'Playfair Display', serif`,
    body: `'Cabin Custom', sans-serif`,
    // cursive fonts
    cursive: `'Shadows Into Light', sans-serif`,
};

export default themeFonts;
